/**
 * #1460 PAY 本体の閲覧計測。
 *
 * これまで PAY 側は**一切数えていなかった**ので、店舗が「載せて意味あった？」と
 * 聞いてきても答えられなかった。EC (#1424) と同じ方針で数える:
 *
 * - **ゲスト（未ログイン）も数える。** 訪日客は未ログインで見て回るので、
 *   ログイン後だけ数えると実態の何分の一かしか見えない
 * - **失敗しても客の画面を止めない。** 計測は付随物なので握り潰す
 * - 個人は追跡しない。サーバは counter を増やすだけ
 */
// PAY の API_BASE は既に `/api/v1` まで含む。ここで再度足すとパスが二重になる
// (`/api/v1/api/v1/...` で 404)。EC 側 (services/ec/frontend) とは基準が違うので使い回さない。
import { API_BASE } from '../services/api/_client'

// 同じ店を開き直すたびに数えない。SPA セッション内で 1 回。
const sent = new Set<string>()

export function trackStoreView(storeId: string): void {
  if (!storeId || sent.has(storeId)) return
  sent.add(storeId)
  // keepalive: 画面遷移で中断されても送り切る
  fetch(`${API_BASE}/metrics/store-view`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ storeId }),
    keepalive: true,
  }).catch(() => { /* 計測の失敗で客の画面を止めない */ })
}
